export default "__VITE_PUBLIC_ASSET__5934659c__"